/* eslint-disable object-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
import React from "react";

import Typography from "@mui/material/Typography";
import { Variant } from "@mui/material/styles/createTypography";

import { isRequired } from "../../logic/utility/isRequired";

interface SompoCardBadgeProps {
    division: string;
    width?: string;
    height?: string;
    variant?: Variant;
}

const SompoCardBadge = (props: SompoCardBadgeProps) =>
    isRequired(props.division) && (
        <Typography
            variant={props.variant || "body2"}
            color="#fff"
            sx={{
                background: "linear-gradient(to right bottom, rgba(0,0,0,0) 50%, #CC0022 50%)",
                width: props.width || "64px",
                height: props.height || "52px",
                border: "0px none",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                paddingBottom: "4px",
                paddingRight: "4px",
            }}
        >
            必須
        </Typography>
    );

export default SompoCardBadge;
